<main class="main-content">
  <article *ngFor="let item of items$ | async; let i = index" class="item"
    [routerLink]="item.elementTypeID && item.elementTypeID === COVER_ELEMENT_TYPE_CONTENTS ? [('/' + item.url + '/' + item[itemKeyName] + '/' + (item.title | slug))] : item.url">
    <img class="image" [src]="item.image" [alt]="item.title" (error)="image.src='../../../../assets/img/default.webp'"
      #image loading="lazy">
    <div class="info">
      <p class="category">{{item.categoryName}}</p>
      <time *ngIf="item.date">{{item.date | date:'mediumDate'}}</time>
      <h4 class="title">{{item.title}}</h4>
    </div>
  </article>
</main>